












































































































































































































































































import Vue from 'vue';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import { FullscreenWrapper } from '@/components/fullscreen-wrapper-components';
import { CloseFullscreenWrapper } from '@/mixins';
import { ExtendMixins } from '@/services';

interface Data {
  pageTitle: string;
  pageSubtitle: string;
  pageDescription: string;
  formModel: any;
  skippedBanking: any;
  hasPrinted: boolean;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
).extend({
  name: 'PrintHSAApplication',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      pageTitle: this.params.title,
      pageSubtitle: this.params.subtitle,
      pageDescription: this.params.description,
      formModel: this.params.formModel,
      skippedBanking: this.params.skippedBanking,
      hasPrinted: false,
    };
  },
  computed: {
    // Form Data
    maskedSSN(): string {
      return InputMaskTypes.ssn.construct(this.formModel.personalInfo.ssn);
    },
    showGroupColumns(): boolean {
      return (
        this.formModel.personalInfo.employerSponsored ||
        this.formModel.personalInfo.agent ||
        this.formModel.personalInfo.offerCode
      );
    },
    groupColumnSize(): number {
      const columns = [];
      // Create columns array
      if (this.formModel.personalInfo.employerSponsored) {
        columns.push('showGroupNumber');
        columns.push('showGroupName');
      }
      if (this.formModel.personalInfo.agent) {
        columns.push('showAgentNumber');
      }
      if (this.formModel.personalInfo.offerCode) {
        columns.push('showOfferCode');
      }
      return columns.length;
    },
    showHSAPlanField(): boolean {
      return (
        !this.formModel.personalInfo.employerSponsored ||
        (this.formModel.personalInfo.employerSponsored &&
          this.formModel.personalInfo.allowChange)
      );
    },
  },
  methods: {
    print(): void {
      this.hasPrinted = true;
      window.print();
    },
  },
  components: {
    FullscreenWrapper,
  },
});
